import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class ScheduleTypesDisplayListComponent implements IController {
  statuses: any;
  isRow: any;
  rowLimit: any;
  onChange: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    if (!this.rowLimit) {
      this.rowLimit = 10;
    }
  }

  $onChanges(changes) {
    if (changes.ids) {
      this.$onInit();
    }
  }

  onRemove(status) {
    this.onChange({statuses: _.filter(this.statuses, (t) => {return t !== status})});
  }

}

angular
  .module('bringoz.admin.schedule')
  .component('scheduleTypesDisplayList', {
    bindings: {
      statuses: '<',
      isRow: '<?',
      rowLimit: '<?',
      onChange: '&'
    },
    template: require('./schedule-types-display-list.html').default,
    controller: ScheduleTypesDisplayListComponent
  });
